import React, { useEffect, useState } from 'react';
import { staffingAPI } from '@/services/staffingAPI';
import { Settings, Building2 } from 'lucide-react';
import ChangePasswordCard from '@/components/shared/ChangePasswordCard';
import EmailVerifyCard from '@/components/shared/EmailVerifyCard';

export default function StaffingSettings() {
  const [ctx, setCtx] = useState(null);
  useEffect(() => { staffingAPI.me().then(setCtx).catch(() => { /* noop */ }); }, []);
  if (!ctx) return null;
  return (
    <div data-testid="staffing-settings">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-6 flex items-center gap-2"><Settings className="w-5 h-5" /> Settings</h1>
      <div className="space-y-6 max-w-2xl">
        <div className="bg-white dark:bg-[#111114] border border-slate-200 dark:border-zinc-800 rounded-xl p-5">
          <p className="text-slate-900 dark:text-white text-sm font-medium mb-3 flex items-center gap-2"><Building2 className="w-4 h-4" /> Organization</p>
          <div className="space-y-2 text-sm">
            <Row label="Name" value={ctx.organization?.name} />
            <Row label="Domain" value={`@${ctx.organization?.domain}`} />
            <Row label="Status" value={
              ctx.organization?.domain_status === 'revoked' ? <span className="text-red-700 dark:text-red-300">Revoked</span>
                : ctx.organization?.org_approved ? <span className="text-emerald-700 dark:text-emerald-300">Approved</span>
                  : <span className="text-amber-700 dark:text-amber-300">Pending admin approval</span>
            } />
            <Row label="Type" value="Staffing" />
          </div>
        </div>
        <EmailVerifyCard testIdPrefix="staffing" />
        <ChangePasswordCard testIdPrefix="staffing-pw" />
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between border-b border-slate-200 dark:border-zinc-800/50 pb-2 last:border-0">
      <span className="text-slate-500 dark:text-zinc-500">{label}</span>
      <span className="text-slate-600 dark:text-zinc-300">{value}</span>
    </div>
  );
}
